
const ButtonSkeleton = () => {
    return (
      <div className="flex items-center justify-center p-2">
        <div 
          className="relative w-24 h-8 overflow-hidden rounded-lg bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-pulse"
        >
          <div 
            className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent animate-shimmer"
          />
        </div>
      </div>
    );
  };

export default ButtonSkeleton;